/* 🤖 this file was generated by svg-to-ts */
export const emperorIconNavigationRight1: {
  name: 'navigation_right_1';
  data: string;
} = {
  name: 'navigation_right_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M22.707 11.29l-9-9c-.29-.29-.72-.38-1.09-.22 -.38.15-.62.52-.62.92v3h-10c-.56 0-1 .44-1 1v4c0 .26.1.52.29.7l6 6c.18.18.44.29.7.29h4v3c0 .4.24.76.61.92 .12.05.25.07.38.07 .26 0 .516-.11.7-.3l9-9c.39-.39.39-1.03 0-1.42ZM7 14.58l-2.59-2.59h2.58v2.58Zm7 4v-1.59c0-.56-.45-1-1-1H9v-5c0-.56-.45-1-1-1H3v-2h10c.55 0 1-.45 1-1V5.4l6.58 6.586 -6.59 6.58Z"/></svg>`,
};
